import mitt from 'mitt';
import { BackgroundJob } from 'graphql-common';

export enum EventBusEvents {
  JobCreated = 'jobCreated',
  JobCompleted = 'jobCompleted',
}

export type JobCompletedPayload = {
  id: string;
  kind: string;
};

export type JobEvents = {
  jobCreated: BackgroundJob;
  jobCompleted: JobCompletedPayload;
};

export const jobEventBus = mitt<JobEvents>();
